import { InjectionToken } from "@angular/core";

export const DEFAULT_USER_DOCS = new InjectionToken<[][any]>('DEFAULT_USER_DOCS')